import { axios } from 'utils/axios';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

type LikesCount = {
  articles: number;
  medications: number;
};

const fetchLikesCount = async (): Promise<LikesCount> => {
  const { data } = await axios.get<LikesCount>('/user/likes/count');
  return data;
};

// Backs the Favorites tab badges. Cheaper than useLikes() for this purpose
// alone (an indexed COUNT per type vs. loading every Like row) — Favorites
// no longer calls useLikes() at all; see useInfiniteLikedContent.ts for the
// scroll-side pagination.
export const useLikesCount = (): UseQueryResult<LikesCount> => {
  return useQuery({
    queryKey: ['likes-count'],
    queryFn: fetchLikesCount,
    // Liking/unliking elsewhere invalidates this, but invalidation only
    // force-refetches *active* queries — while Favorites is unmounted this
    // just gets marked stale, and relying on that to reliably trigger a
    // refetch on the next mount is exactly what was going stale. Always
    // refetch on mount instead so opening Favorites is never in question.
    refetchOnMount: 'always',
  });
};
